import "./index.css";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import FoodManagementPage from "./pages/FoodManagementPage";
import RestaurantManagementPage from "./pages/RestaurantManagementPage";
import PaymentPage from "./pages/PaymentPage";

function App() {
  const path = window.location.pathname;
  if (path === "/dashboard") return <DashboardPage />;
  if (path === "/food") return <FoodManagementPage />;
  if (path === "/restaurant") return <RestaurantManagementPage />;
  if (path === "/payment") return <PaymentPage />;
  return <AuthPage />;
}

export default App;